module.exports = __webpack_public_path__ + "53281b9018265f595a5354ad74f6b2a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/interview_0.jpg
// module id = 544
// module chunks = 0